import { Button, Col, Form, Input, Row, Space } from "antd";
import "./styles.scss";
import TextArea from "antd/es/input/TextArea";
import { ReactSVG } from "react-svg";
import { CONTACT_FB } from "assets";
import { CONTACT_TWITTER } from "assets";

const ContactSection = () => {
  return (
    <section className="contact-section">
      <div className="contact-section-inner container">
        <Row gutter={[40, 40]} justify={"space-between"}>
          <Col xs={{ span: 24, order: 2 }} lg={{ span: 8, order: 1 }}>
            <ContactDetails />
          </Col>
          <Col xs={{ span: 24, order: 1 }} lg={{ span: 16, order: 2 }}>
            <ContactForm />
          </Col>
        </Row>
      </div>
    </section>
  );
};

export default ContactSection;

const ContactDetails = () => (
  <Space direction="vertical" size={25}>
    <div className="contact-item">
      <p className="m-0 font-16 text-black-subtle font-w-semi-bold">
        Send us an email
      </p>
      <a href="mailto:sales@agapeit.tech">sales@agapeit.tech</a>
    </div>
    <div className="contact-item">
      <p className="m-0 font-16 text-black-subtle font-w-semi-bold">
        Reach us at
      </p>
      <a href="tel:+447921841924">+447921841924</a>
    </div>
    <div className="contact-item">
      <p className="m-0 font-16 text-black-subtle font-w-semi-bold">
        Follow us on
      </p>
      <Space className="contact-social-icons" size={20}>
        <ReactSVG src={CONTACT_FB} />
        <ReactSVG src={CONTACT_TWITTER} />
      </Space>
    </div>
  </Space>
);

const ContactForm = () => (
  <div className="contact-form-wrapper">
    <h1>Hey! Got a Project?</h1>
    <Form layout="vertical">
      <Row gutter={[20, 0]}>
        <Col xs={12}>
          <Form.Item label="First Name">
            <Input placeholder="First Name" />
          </Form.Item>
        </Col>
        <Col xs={12}>
          <Form.Item label="Last Name">
            <Input placeholder="Last Name" />
          </Form.Item>
        </Col>
        <Col xs={12}>
          <Form.Item label="Organisation">
            <Input placeholder="Organisation" />
          </Form.Item>
        </Col>
        <Col xs={12}>
          <Form.Item label="Contact Number">
            <Input placeholder="Contact Number" />
          </Form.Item>
        </Col>
        <Col xs={24}>
          <Form.Item label="Email Address">
            <Input placeholder="example@mail.com" />
          </Form.Item>
        </Col>
        <Col xs={24}>
          <Form.Item label="Tell us more about your requirement">
            <TextArea />
          </Form.Item>
        </Col>
      </Row>
      <Button type="primary" size="large">
        Submit
      </Button>
    </Form>
  </div>
);
